import { IconAction } from '@nimmsta/ng-commons-lib/data-table';
import { Observable, of } from 'rxjs';
import { Configuration, State } from '../../models/configuration';

export class PendingDownloadAction extends IconAction<Configuration> {
  constructor(isActive?: (id: string) => boolean) {
    super('download', 'downloading', false, isActive);
  }

  override isEnabled(configuration: Configuration): Observable<boolean> {
    return of(configuration.state === State.SUBMITTED);
  }
}
